module.exports = {
  context: {
    articles: [
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Post Heading'
        },
        heading: 'Adjoin to partner with STRIVE',
        shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.',
        date: 'February 24, 2021',
        entryType: 'Press Release',
        button: {
          text: 'Read More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Post Heading'
        },
        heading: 'Post Heading',
        shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.',
        date: 'Date',
        entryType: 'Entry Type',
        button: {
          text: 'Read More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Post Heading'
        },
        heading: 'Post Heading',
        shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.',
        date: 'Date',
        entryType: 'Entry Type',
        button: {
          text: 'Read More',
          url: 'https://google.com',
          class: 'cta'
        }
      }
    ]
  }
}
